import { render, staticRenderFns } from "./dashboardStatsByStatus.vue?vue&type=template&id=594225d6&"
import script from "./dashboardStatsByStatus.vue?vue&type=script&lang=js&"
export * from "./dashboardStatsByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports